import { useMemo } from 'react';
import { reduce, merge } from 'lodash';
import { Box } from '@material-ui/core';

import StatusBreakout from '../../charts/status-breakout/StatusBreakout';
import { businessServiceGroupFilterId } from '../../filters';
import { useFilterState, useIsFilterActive } from '../../../stores/FilterStateStore';
import { useDataSource } from '../../../services/ApiDataService';
import { useSetIsLoading } from './MapPanelLoadingContext';

const BREAKOUT_HEIGHT = 70;

const siteCountsDataSource = {
    url: '/query/chart',
    params: {
        type: 'site',
        site: '00000000-0000-0000-0000-000000000000',
        metrics: ['aggStatusCounts'],
    },
};

const bsCountsDataSource = {
    url: '/query/chart',
    params: {
        type: 'businessservice',
        metrics: ['bsSiteCounts'],
        invertEntityFilters: true,
    },
};

export default function SiteStatusBreakout(props) {
    const { onTimeRangeChange } = props;
    const [isBSFilterActive] = useIsFilterActive(businessServiceGroupFilterId);
    const [filterState] = useFilterState();

    const filterParams = useMemo(() => {
        return reduce(filterState?.parameters || {}, merge, {});
    }, [filterState]);

    const countsDataSource = isBSFilterActive ? bsCountsDataSource : siteCountsDataSource;
    const [countsData, isLoading] = useDataSource(countsDataSource, filterParams);

    useSetIsLoading(isLoading);

    if (!countsData) return <Box height={BREAKOUT_HEIGHT} />;

    const { data, legend } = countsData;

    return (
        <StatusBreakout
            height={BREAKOUT_HEIGHT}
            onTimeRangeChange={onTimeRangeChange}
            data={data?.[0]}
            metricName={legend?.[0]}
        />
    );
}
